export interface IApiEmailNotificationSettings {
  DateFinder?: boolean;
  Events?: boolean;
  MatchReport?: boolean;
  Offers?: boolean;
  RHPTeamMessages?: boolean;
}

export default class EmailNotificationSettings {
  dateFinder: boolean;
  events: boolean;
  matchReport: boolean;
  offers: boolean;
  rhpTeamMessages: boolean;

  constructor() {
    this.dateFinder = false;
    this.events = false;
    this.matchReport = false;
    this.offers = false;
    this.rhpTeamMessages = false;
  }

  static mappingObject(_obj: IApiEmailNotificationSettings): EmailNotificationSettings {
    const obj = new EmailNotificationSettings();
    obj.dateFinder = _obj.DateFinder || false;
    obj.events = _obj.Events || false;
    obj.matchReport = _obj.MatchReport || false;
    obj.offers = _obj.Offers || false;
    obj.rhpTeamMessages = _obj.RHPTeamMessages || false;

    return obj;
  }
}
